import { DashboardAccountsService, DashboardAuthService, DashboardCameraCalibrationService, DashboardCatalogService, DashboardClustersService, DashboardDatasetsService, DashboardDevicesService, DashboardEmailReportsService, DashboardLookupTablesService, DashboardModelsService, DashboardNotificationsService, DashboardPendingSampleActionsService, DashboardPredictionsService, DashboardReportsService, DashboardSamplesService, DashboardScheduledTrainingsService, DashboardSessionsService, DashboardSitesService, DashboardSyncGroundTruthsService, DashboardTagsService, DashboardTrainingsService, DashboardUploadVideosService, DashboardCapacityTaggingService, DashboardRecoveryEstimatesService, DashboardHeadBlurImagesService, DashboardHeadBlurVideosService, DashboardUsersService, DashboardDashboardAlertsService, DashboardDevicesTaggingService, CurrencyService, VersionService, DashboardPageViewsService, DashboardCatalogTaggingService, DashboardSitesTaggingService, DashboardClustersTaggingService, DashboardPermissionsService, DashboardSessionsTaggingService, DashboardQueuesService, DashboardAlertsService, DashboardDeployComponentsService, DashboardJiraService, DashboardScheduleModelDeploymentsService, DashboardScheduleConfigDeploymentsService, DashboardWorkerJobService, DashboardServiceHealthChecksService, DashboardLabelDistributionService, DashboardUploadSamplesService, DashboardDeleteSamplesService, DashboardDeleteVideosService, DashboardFeedbackService, DashboardSlackService, DashboardSiteGroupsService, DashboardDeviceRestartService, DashboardStaticDatasetsService, DashboardCatalogUploadJobsService, DashboardMetricAlertsService, DashboardDomainAuthSettingsService, DashboardRegionsService, DashboardReportsCompanionService } from "./__generated__/sdk.gen";
import { OpenAPI } from "./__generated__/core/OpenAPI";

import { extend, qs } from "./extend";
import { FullStory } from "@fullstory/browser";
import { router, queryClient } from "@/state/router";
export * from "./__generated__";
export * from "./__generated__/schemas.gen";
import { toast } from "sonner";
import { t } from "i18next";

const DevicesService = () =>
  ({
    create: extend(DashboardDevicesService.devicesControllerCreate),
    update: extend(DashboardDevicesService.devicesControllerUpdate),
    getDetails: extend(DashboardDevicesService.devicesControllerGetDetails),
    listSummaries: extend(DashboardDevicesService.devicesControllerListSummaries),
    listMinimal: extend(DashboardDevicesService.devicesControllerListMinimal),
    stateCounts: extend(DashboardDevicesService.devicesControllerStateCounts),

    getSamples: extend(DashboardDevicesService.devicesControllerGetSamples),
    getSamplesSize: extend(DashboardDevicesService.devicesControllerGetSamplesSize),
    getSamplesStats: extend(DashboardDevicesService.devicesControllerGetSamplesStats),

    unlockSamples: extend(DashboardDevicesService.devicesControllerUnlockSamples),
    unlockSamplesByUUIDs: extend(DashboardDevicesService.devicesControllerUnlockSamplesByUuids),
    unlockAllSamples: extend(DashboardDevicesService.devicesControllerUnlockAllSamples),
    // GetSamplesQueryResponseDto, equal in structure to PaginatedResponse<SampleDto>

    startRecording: extend(DashboardDevicesService.devicesControllerStartRecording),
    stopRecording: extend(DashboardDevicesService.devicesControllerStopRecording),

    testAlertNonMatch: extend(DashboardDevicesService.devicesControllerTestAlertNonMatch),
    testAlertNonScan: extend(DashboardDevicesService.devicesControllerTestAlertNonScan),
    testAlertLeftInCart: extend(DashboardDevicesService.devicesControllerTestAlertLeftInCart),

    startVideoUpload: extend(DashboardDevicesService.devicesControllerStartVideoUpload),
    stopVideoUpload: extend(DashboardDevicesService.devicesControllerStopVideoUpload),
    getVideoUploadState: extend(DashboardDevicesService.devicesControllerGetVideoUploadState),

    startSamplesUpload: extend(DashboardDevicesService.devicesControllerStartSamplesUpload),
    stopSamplesUpload: extend(DashboardDevicesService.devicesControllerStopSamplesUpload),
    getSamplesUploadState: extend(DashboardDevicesService.devicesControllerGetSamplesUploadState),
    listSamplesUploads: extend(DashboardDevicesService.devicesControllerListSamplesUploads),
    getSamplesUploadStateByName: extend(DashboardDevicesService.devicesControllerGetSamplesUploadStateByName),
    listVideoUploads: extend(DashboardDevicesService.devicesControllerListVideoUploads),
    getVideoUploadStateByName: extend(DashboardDevicesService.devicesControllerGetVideoUploadStateByName),

    startHeadBlurImages: extend(DashboardDevicesService.devicesControllerStartHeadBlurImages),
    stopHeadBlurImages: extend(DashboardDevicesService.devicesControllerStopHeadBlurImages),
    getHeadBlurImagesState: extend(DashboardDevicesService.devicesControllerGetHeadBlurImagesState),
    listHeadBlurImages: extend(DashboardDevicesService.devicesControllerListHeadBlurImages),
    getHeadBlurImagesStateByName: extend(DashboardDevicesService.devicesControllerGetHeadBlurImagesStateByName),
    headBlurImage: extend(DashboardDevicesService.devicesControllerHeadBlurImage),

    startHeadBlurVideos: extend(DashboardDevicesService.devicesControllerStartHeadBlurVideos),
    stopHeadBlurVideos: extend(DashboardDevicesService.devicesControllerStopHeadBlurVideos),
    getHeadBlurVideosState: extend(DashboardDevicesService.devicesControllerGetHeadBlurVideosState),
    // The single, currently-processed video on the agent — not scoped to a job.
    getHeadBlurVideoState: extend(DashboardDevicesService.devicesControllerGetHeadBlurVideoState),
    listHeadBlurVideos: extend(DashboardDevicesService.devicesControllerListHeadBlurVideos),
    getHeadBlurVideosStateByName: extend(DashboardDevicesService.devicesControllerGetHeadBlurVideosStateByName),

    sample: extend(DashboardDevicesService.devicesControllerGetSample),
    uploadLogs: extend(DashboardDevicesService.devicesControllerUploadLogs),
    uploadTrainerLogs: extend(DashboardDevicesService.devicesControllerUploadTrainerLogs),
    // #TODO: find a way to use the client for this -- raw URL, so it never passes through the
    // request interceptor below; the account currently being viewed has to be attached directly.
    sampleLink: ({ sampleId, deviceId, raw }: { sampleId: string; deviceId: number | string; raw?: boolean }) => {
      const accountId = (router.state.location.search as { accountId?: number } | undefined)?.accountId;
      return `${OpenAPI.BASE}/api/v2/dashboard/devices/${deviceId}/samples/${sampleId}/image${qs({
        raw,
        viewAccountId: accountId,
      })}`;
    },

    sampleThumbnail: extend(DashboardDevicesService.devicesControllerGetSample),
    // #TODO: find a way to use the client for this -- see sampleLink above.
    sampleThumbnailLink: ({ sampleId, deviceId, raw, width, height }: { sampleId: string; deviceId: number | string; width?: number; height?: number; raw?: boolean }) => {
      const accountId = (router.state.location.search as { accountId?: number } | undefined)?.accountId;
      return `${OpenAPI.BASE}/api/v2/dashboard/devices/${deviceId}/samples/${sampleId}/thumbnail${qs({
        raw,
        width,
        height,
        viewAccountId: accountId,
      })}`;
    },

    capture: extend(DashboardDevicesService.devicesControllerCapture),
    captureAndPredict: extend(DashboardDevicesService.devicesControllerCaptureAndPredict),
    predict: extend(DashboardDevicesService.devicesControllerPredict),
    addSample: extend(DashboardDevicesService.devicesControllerAddSample),
    saveSample: extend(DashboardDevicesService.devicesControllerSaveSample),
    deleteSamples: extend(DashboardDevicesService.devicesControllerDeleteSamples),
    syncSamples: extend(DashboardDevicesService.devicesControllerSyncSamples),

    getSessions: extend(DashboardDevicesService.devicesControllerGetSessions),
    getSessionsSize: extend(DashboardDevicesService.devicesControllerGetSessionsSize),
    // GetSessionsResponseDto, equal in structure to PaginatedResponse<SessionDto>,
    deleteSession: extend(DashboardDevicesService.devicesControllerDeleteSession),
    syncSessions: extend(DashboardDevicesService.devicesControllerSyncSessions),
    getAgentDeployments: extend(DashboardDevicesService.devicesControllerGetAgentDeployments),
    deployAgentVersion: extend(DashboardDevicesService.devicesControllerDeployAgentVersion),
    getServiceDeployments: extend(DashboardDevicesService.devicesControllerGetServiceDeployments),
    deployServiceVersion: extend(DashboardDevicesService.devicesControllerDeployService),
    updateActivations: extend(DashboardDevicesService.devicesControllerUpdateActivationTime),
    deployModelBulk: extend(DashboardDevicesService.devicesControllerDeployModelBulk),
    deployServiceVersionBulk: extend(DashboardDevicesService.devicesControllerDeployServiceVersionBulk),
    getAvailableServiceVersions: extend(DashboardDevicesService.devicesControllerGetAvailableServiceVersions),
    listAvailableComponentVersions: extend(DashboardDevicesService.devicesControllerListAvailableComponentVersions),

    getConfig: extend(DashboardDevicesService.devicesControllerGetConfig),
    setConfig: extend(DashboardDevicesService.devicesControllerSetConfig),
    listConfigDeployments: extend(DashboardDevicesService.devicesControllerListConfigDeployments),
    deployConfigBulk: extend(DashboardDevicesService.devicesControllerDeployConfigBulk),
    restart: extend(DashboardDevicesService.devicesControllerRestart),
    restartBulk: extend(DashboardDevicesService.devicesControllerRestartBulk),
    listCameras: extend(DashboardDevicesService.devicesControllerListCameras),
    listInternalCameras: extend(DashboardDevicesService.devicesControllerListInternalCameras),
    listExternalCamera: extend(DashboardDevicesService.devicesControllerListExternalCamera),
    getCameraControls: extend(DashboardDevicesService.devicesControllerGetCameraControls),
    setCameraControls: extend(DashboardDevicesService.devicesControllerSetCameraControls),
    getConfigLockState: extend(DashboardDevicesService.devicesControllerGetConfigLockState),
    updateConfigLockBulk: extend(DashboardDevicesService.devicesControllerUpdateConfigLockBulk),
    revertConfig: extend(DashboardDevicesService.devicesControllerRevertConfig),
    cancelPendingConfig: extend(DashboardDevicesService.devicesControllerCancelConfig),
    testConnection: extend(DashboardDevicesService.devicesControllerTestConnection),
    getCertValidity: extend(DashboardDevicesService.devicesControllerGetCertValidity),
    getConfigFile: extend(DashboardDevicesService.devicesControllerGetConfigFile),
    disableDeviceAlerts: extend(DashboardDevicesService.devicesControllerDisableDeviceAlerts),
    enableDeviceAlerts: extend(DashboardDevicesService.devicesControllerEnableDeviceAlerts),
    deviceAlertsStatus: extend(DashboardDevicesService.devicesControllerGetDeviceAlertsStatus),
    setDeviceAlerts: extend(DashboardDevicesService.devicesControllerSetDeviceAlerts),

    listTags: extend(DashboardDevicesTaggingService.devicesTaggingControllerListTags),
    // updateTags: extend(DashboardDevicesService.devicesControllerUpdateTags),
    updateTagsBulk: extend(DashboardDevicesService.devicesControllerUpdateTagsBulk),
    getTags: extend(DashboardDevicesTaggingService.devicesTaggingControllerListTags),
    getTagDetails: extend(DashboardDevicesTaggingService.devicesTaggingControllerGetDetails),
    updateTag: extend(DashboardDevicesTaggingService.devicesTaggingControllerUpdateTag),
    deleteTag: extend(DashboardDevicesTaggingService.devicesTaggingControllerDeleteTag),
    mergeTags: extend(DashboardDevicesTaggingService.devicesTaggingControllerMergeTagTo),
    createTags: extend(DashboardDevicesTaggingService.devicesTaggingControllerCreateTags),

    uploadCSV: extend(DashboardDevicesService.devicesControllerUpload),
    listEvents: extend(DashboardDevicesService.devicesControllerListDeviceEvents),
  }) as const;

const ClustersService = () =>
  ({
    create: extend(DashboardClustersService.clustersControllerCreate),
    update: extend(DashboardClustersService.clustersControllerUpdate),
    delete: extend(DashboardClustersService.clustersControllerDelete),
    getDetails: extend(DashboardClustersService.clustersControllerGetDetails),
    listSummaries: extend(DashboardClustersService.clustersControllerListSummaries),
    listMinimal: extend(DashboardClustersService.clustersControllerListMinimal),
    deployModelBulk: extend(DashboardClustersService.clustersControllerDeployModelBulk),
    unAssignDevicesBulk: extend(DashboardClustersService.clustersControllerRemoveDevices),
    assignDevicesBulk: extend(DashboardClustersService.clustersControllerAddDevices),
    listTags: extend(DashboardClustersTaggingService.clustersTaggingControllerListTags),
    updateTagsBulk: extend(DashboardClustersService.clustersControllerUpdateTagsBulk),
    getTags: extend(DashboardClustersTaggingService.clustersTaggingControllerListTags),
    getTagDetails: extend(DashboardClustersTaggingService.clustersTaggingControllerGetDetails),
    updateTag: extend(DashboardClustersTaggingService.clustersTaggingControllerUpdateTag),
    deleteTag: extend(DashboardClustersTaggingService.clustersTaggingControllerDeleteTag),
    mergeTags: extend(DashboardClustersTaggingService.clustersTaggingControllerMergeTagTo),
    createTags: extend(DashboardClustersTaggingService.clustersTaggingControllerCreateTags),
    deployConfigBulk: extend(DashboardClustersService.clustersControllerDeployConfigBulk),
    uploadCSV: extend(DashboardClustersService.clustersControllerUpload),
  }) as const;

const AuthService = () =>
  ({
    login: extend(DashboardAuthService.authControllerLogin),
    logout: extend(DashboardAuthService.authControllerLogout),
    accountSwitch: extend(DashboardAuthService.authControllerAccountSwitch),
  }) as const;

const UsersService = () =>
  ({
    getAllUsers: extend(DashboardUsersService.usersControllerFindAll),
    getUserById: extend(DashboardUsersService.usersControllerFindOne),
    createNewUser: extend(DashboardUsersService.usersControllerCreate),
    me: extend(DashboardUsersService.usersControllerMe),
    updateTableSettings: extend(DashboardUsersService.usersControllerUpdateTableSettings),
    deleteTableSettings: extend(DashboardUsersService.usersControllerDeleteTableSettings),
    getRelatedAccounts: extend(DashboardUsersService.usersControllerRelatedAccounts),
    updateUser: extend(DashboardUsersService.usersControllerUpdate), // update self - minimal permissions
    adminUpdateUser: extend(DashboardUsersService.usersControllerAdminUpdate), // update as admin - full permissions
    inviteUsersToReport: extend(DashboardUsersService.usersControllerInviteUsersToReport),
    listEmails: extend(DashboardUsersService.usersControllerListEmails),
    listMinimal: extend(DashboardUsersService.usersControllerListMinimal),
    deleteUser: extend(DashboardUsersService.usersControllerRemove),
    checkUser: extend(DashboardUsersService.usersControllerCheckUser),
    assignSites: extend(DashboardUsersService.usersControllerAssignSites),
    getRoleCreatePermission: extend(DashboardUsersService.usersControllerGetRoleCreatePermission),
    deleteUsersBulk: extend(DashboardUsersService.usersControllerDeleteUsersBulk),
  }) as const;

const AlertsService = () =>
  ({
    listAlerts: extend(DashboardAlertsService.alertsControllerListAlerts),
    getAlertDetails: extend(DashboardAlertsService.alertsControllerGetAlertById),
    updateAlert: extend(DashboardAlertsService.alertsControllerUpdateAlert),
    updateAlertSubscription: extend(DashboardAlertsService.alertsControllerUpdateAlertSubscriptions),
    getAlertEscalation: extend(DashboardAlertsService.alertsControllerGetAlertEscalation),
    updateAlertEscalation: extend(DashboardAlertsService.alertsControllerUpdateAlertEscalation),
    listAlertChannels: extend(DashboardAlertsService.alertsControllerListAlertChannels),
    createAlertChannel: extend(DashboardAlertsService.alertsControllerCreateAlertChannel),
    createGlobalAlertChannel: extend(DashboardAlertsService.alertsControllerCreateGlobalAlertChannel),
    updateAlertChannel: extend(DashboardAlertsService.alertsControllerUpdateAlertChannel),
    updateGlobalAlertChannel: extend(DashboardAlertsService.alertsControllerUpdateGlobalAlertChannel),
    deleteAlertChannel: extend(DashboardAlertsService.alertsControllerDeleteAlertChannel),
    deleteGlobalAlertChannel: extend(DashboardAlertsService.alertsControllerDeleteGlobalAlertChannel),
    listAlertDeliveries: extend(DashboardAlertsService.alertsControllerListAlertDeliveries),
    updateAccountAlert: extend(DashboardAlertsService.alertsControllerUpdateAccountAlert),
    listManagedAlerts: extend(DashboardAlertsService.alertsControllerListManagedAlerts),
    listManagedAlertsGroupedByEvent: extend(DashboardAlertsService.alertsControllerListManagedAlertsGroupedByEvent),
    updateManagedAlertStatus: extend(DashboardAlertsService.alertsControllerUpdateManagedAlertStatus),
    updateManagedAlertStatusBulk: extend(DashboardAlertsService.alertsControllerUpdateManagedAlertStatusBulk),
    emitTestAlert: extend(DashboardAlertsService.alertsControllerEmitTestAlert),
  }) as const;

const SamplesService = () =>
  ({
    getDetails: extend(DashboardSamplesService.samplesControllerGetSampleDetails),
    getDetailsAndImage: extend(DashboardSamplesService.samplesControllerGetSampleDetailsAndImage),
    getImage: extend(DashboardSamplesService.samplesControllerGetSampleImage),
    // #TODO: find a way to use the client for this. The endpoint is public, but the session cookie goes
    // along with it, and `accountId` (sent as viewAccountId) makes that session resolve to the account the
    // sample is in -- the backend narrows its lookup to it (ground_truths is partitioned by account).
    getImageLink: ({ uuid, raw, accountId }: { uuid: string; raw?: boolean; accountId?: number }) => `${OpenAPI.BASE}/api/v2/dashboard/samples/${uuid}/image${qs({ raw, viewAccountId: accountId })}`,
    getThumbnail: extend(DashboardSamplesService.samplesControllerGetSampleThumbnail),
    // #TODO: find a way to use the client for this -- see getImageLink above.
    getThumbnailLink: ({ uuid, raw, width, height, accountId }: { uuid: string; raw?: boolean; width?: number; height?: number; accountId?: number }) =>
      `${OpenAPI.BASE}/api/v2/dashboard/samples/${uuid}/thumbnail${qs({
        raw,
        width,
        height,
        viewAccountId: accountId,
      })}`,
    getImageInDevice: extend(DashboardSamplesService.samplesControllerGetSampleImageInDevice),
    getUxSource: extend(DashboardSamplesService.samplesControllerGetUxSource),
    // #TODO: find a way to use the client for this -- raw URL, so it never passes through the
    // request interceptor below; the account currently being viewed has to be attached directly.
    getImageInDeviceLink: ({ uuid, deviceId, raw }: { uuid: string; deviceId: number; raw?: boolean }) => {
      const accountId = (router.state.location.search as { accountId?: number } | undefined)?.accountId;
      return `${OpenAPI.BASE}/api/v2/dashboard/samples/${uuid}/image-in-device${qs({
        deviceId,
        raw,
        viewAccountId: accountId,
      })}`;
    },
    listSamples: extend(DashboardSamplesService.samplesControllerListSamples),
    listSamplesCount: extend(DashboardSamplesService.samplesControllerListSamplesCount),

    updateSample: extend(DashboardSamplesService.samplesControllerUpdateSample),
    updateSampleMetadata: extend(DashboardSamplesService.samplesControllerUpdateSampleMetadata),
    updateSampleMetadataBulk: extend(DashboardSamplesService.samplesControllerUpdateSamplesMetadataBulk),
    updateLoss: extend(DashboardSamplesService.samplesControllerUpdateLoss),
    updateGroupLoss: extend(DashboardSamplesService.samplesControllerUpdateGroupLoss),
    // refreshLoss: extend(DashboardSamplesService.samplesControllerRefreshLoss),
    refreshLossBulk: extend(DashboardSamplesService.samplesControllerRefreshLossBulk),
    deleteSample: extend(DashboardSamplesService.samplesControllerDeleteSample),
    deleteSamplesBulk: extend(DashboardSamplesService.samplesControllerDeleteBulk),
    updateSamples: extend(DashboardSamplesService.samplesControllerUpdateBulk),
    updateTagsBulk: extend(DashboardSamplesService.samplesControllerUpdateTagsBulk),

    uploadSample: extend(DashboardSamplesService.samplesControllerUploadSample),
    uploadBulk: extend(DashboardSamplesService.samplesControllerUploadBulk),

    setRepresentativeImagesBulk: extend(DashboardSamplesService.samplesControllerSetRepresentativeImageBulk),
  }) as const;

const SessionsService = () =>
  ({
    getSession: extend(DashboardSessionsService.sessionsControllerGetSession),
    listSessions: extend(DashboardSessionsService.sessionsControllerListSessions),
    listSessionsCount: extend(DashboardSessionsService.sessionsControllerListSessionsCount),
    listSessionsAlerts: extend(DashboardSessionsService.sessionsControllerListSessionsAlerts),
    // listSessionsAlertsCount: extend(DashboardSessionsService.sessionsControllerListSessionsAlertsCount),
    getTags: extend(DashboardSessionsTaggingService.sessionsTaggingControllerListTags),
    updateTagsBulk: extend(DashboardSessionsService.sessionsControllerUpdateTagsBulk),
    getTagDetails: extend(DashboardSessionsTaggingService.sessionsTaggingControllerGetDetails),
    updateAssigneeBulk: extend(DashboardSessionsService.sessionsControllerUpdateAssigneeBulk),
    updateTag: extend(DashboardSessionsTaggingService.sessionsTaggingControllerUpdateTag),
    deleteTag: extend(DashboardSessionsTaggingService.sessionsTaggingControllerDeleteTag),
    mergeTags: extend(DashboardSessionsTaggingService.sessionsTaggingControllerMergeTagTo),
    createTags: extend(DashboardSessionsTaggingService.sessionsTaggingControllerCreateTags),
  }) as const;

const PredictionsService = () =>
  ({
    listPredictions: extend(DashboardPredictionsService.predictionsControllerListPredictions),
    listPredictionsCount: extend(DashboardPredictionsService.predictionsControllerListPredictionsCount),
    listModelPredictions: extend(DashboardPredictionsService.predictionsControllerListModelPredictions),
    listModelPredictionsCount: extend(DashboardPredictionsService.predictionsControllerListModelPredictionsCount),
  }) as const;

const DatasetsService = () =>
  ({
    create: extend(DashboardDatasetsService.datasetsControllerCreate),
    update: extend(DashboardDatasetsService.datasetsControllerUpdate),
    getDetails: extend(DashboardDatasetsService.datasetsControllerGetDetails),
    listSummaries: extend(DashboardDatasetsService.datasetsControllerListSummaries),
  }) as const;

const StaticDatasets = () =>
  ({
    listDatasets: extend(DashboardStaticDatasetsService.staticDatasetsControllerList),
    listMinimal: extend(DashboardStaticDatasetsService.staticDatasetsControllerListMinimal),
    getDetails: extend(DashboardStaticDatasetsService.staticDatasetsControllerGetDetails),
    uploadDataset: extend(DashboardStaticDatasetsService.staticDatasetsControllerUpload),
    startDataset: extend(DashboardStaticDatasetsService.staticDatasetsControllerStart),
    deleteDataset: extend(DashboardStaticDatasetsService.staticDatasetsControllerDelete),
    analyzeDataset: extend(DashboardStaticDatasetsService.staticDatasetsControllerAnalyze),
    createDataset: extend(DashboardStaticDatasetsService.staticDatasetsControllerCreate),
    countSamples: extend(DashboardStaticDatasetsService.staticDatasetsControllerCountSamples),
    createEmptyDataset: extend(DashboardStaticDatasetsService.staticDatasetsControllerCreateEmpty),
    addSamplesFromFilter: extend(DashboardStaticDatasetsService.staticDatasetsControllerAddSamplesFromFilter),
    retryMissingSamples: extend(DashboardStaticDatasetsService.staticDatasetsControllerRetryMissingSamples),
    recalculateAnalytics: extend(DashboardStaticDatasetsService.staticDatasetsControllerRecalculateAnalytics),
    resumeFromSamples: extend(DashboardStaticDatasetsService.staticDatasetsControllerResumeFromSamples),
    addSessionsFromFilter: extend(DashboardStaticDatasetsService.staticDatasetsControllerAddSessionsFromFilter),
    retryMissingSessions: extend(DashboardStaticDatasetsService.staticDatasetsControllerRetryMissingSessions),
    resumeFromSessions: extend(DashboardStaticDatasetsService.staticDatasetsControllerResumeFromSessions),
  }) as const;

const TagsService = () =>
  ({
    create: extend(DashboardTagsService.tagsControllerCreate),
    assign: extend(DashboardTagsService.tagsControllerAssignTags),
    unassign: extend(DashboardTagsService.tagsControllerUnassignTags),
    set: extend(DashboardTagsService.tagsControllerSetTags),
    assignGroup: extend(DashboardTagsService.tagsControllerAssignGroupTags),
    unassignGroup: extend(DashboardTagsService.tagsControllerUnassignGroupTags),
    setGroup: extend(DashboardTagsService.tagsControllerSetGroupTags),
    updateGroup: extend(DashboardTagsService.tagsControllerUpdateGroupTags),
    listSummaries: extend(DashboardTagsService.tagsControllerListTags),
    getTagDetails: extend(DashboardTagsService.tagsControllerGetDetails),
    updateTag: extend(DashboardTagsService.tagsControllerUpdate),
    deleteTag: extend(DashboardTagsService.tagsControllerDelete),
    mergeTags: extend(DashboardTagsService.tagsControllerMergeTagTo),
    createTags: extend(DashboardTagsService.tagsControllerCreate),
  }) as const;

const ModelsService = () =>
  ({
    update: extend(DashboardModelsService.modelsControllerUpdate),
    upload: extend(DashboardModelsService.modelsControllerUploadModel),
    download: extend(DashboardModelsService.modelsControllerDownloadModel),
    // #TODO: find a way to use the client for this -- raw URL, so it never passes through the
    // request interceptor below; the account currently being viewed has to be attached here
    // directly or ValidateModelGuard denies the download for any non-default-account model.
    downloadLink: ({ id }: { id: number }) => {
      const accountId = (router.state.location.search as { accountId?: number } | undefined)?.accountId;
      return `${OpenAPI.BASE}/api/v2/dashboard/models/download/${id}${qs({ viewAccountId: accountId })}`;
    },
    getDetails: extend(DashboardModelsService.modelsControllerGetDetails),
    listSummaries: extend(DashboardModelsService.modelsControllerListSummaries),
    listMinimal: extend(DashboardModelsService.modelsControllerListMinimal),
    listDeployments: extend(DashboardModelsService.modelsControllerListDeployments),
    listClusterModelDeployments: extend(DashboardModelsService.modelsControllerListClusterDeployments),
    listRoles: extend(DashboardModelsService.modelsControllerListModelRoles),
    deploy: extend(DashboardModelsService.modelsControllerDeployModel),
  }) as const;

const TrainingService = () =>
  ({
    create: extend(DashboardTrainingsService.trainingsControllerCreateTraining),
    cancel: extend(DashboardTrainingsService.trainingsControllerCancelTraining),
    update: extend(DashboardTrainingsService.trainingsControllerUpdate),
    deleteBulk: extend(DashboardTrainingsService.trainingsControllerDeleteTrainingsBulk),
    cancelBulk: extend(DashboardTrainingsService.trainingsControllerCancelTrainingsBulk),
    getDetails: extend(DashboardTrainingsService.trainingsControllerGetDetails),
    listSummaries: extend(DashboardTrainingsService.trainingsControllerListSummaries),
    getParticipations: extend(DashboardTrainingsService.trainingsControllerGetParticipations),
    getSamples: extend(DashboardTrainingsService.trainingsControllerGetSampleStats),
    getTrainingExecutionDetails: extend(DashboardTrainingsService.trainingsControllerGetTrainingExecutionDetails),
    createModel: extend(DashboardTrainingsService.trainingsControllerCreateModel),
    // the container versions / config a new training job starts from
    getDefaults: extend(DashboardTrainingsService.trainingsControllerGetDefaults),
    updateDefaults: extend(DashboardTrainingsService.trainingsControllerUpdateDefaults),
    clearDefaults: extend(DashboardTrainingsService.trainingsControllerClearDefaults),
  }) as const;

const AccountsService = () =>
  ({
    findOne: extend(DashboardAccountsService.accountsControllerFindOne),
    create: extend(DashboardAccountsService.accountsControllerCreate),
    update: extend(DashboardAccountsService.accountsControllerUpdate),
    updateById: extend(DashboardAccountsService.accountsControllerUpdateById),
    listSummaries: extend(DashboardAccountsService.accountsControllerListSummaries),
    listMinimal: extend(DashboardAccountsService.accountsControllerListMinimal),
    updateIsActiveBulk: extend(DashboardAccountsService.accountsControllerUpdateIsActiveBulk),
    listAvailableAgentVersions: extend(DashboardAccountsService.accountsControllerListAvailableAgentVersions),
    listAvailableServiceVersions: extend(DashboardAccountsService.accountsControllerListAvailableServiceVersions),
    upsertDefaultOperationalHours: extend(DashboardAccountsService.accountsControllerUpsertDefaultOperationalHours),
  }) as const;

const ScheduledTrainings = () => ({
  create: extend(DashboardScheduledTrainingsService.scheduledTrainingsControllerCreateScheduledTraining),
  update: extend(DashboardScheduledTrainingsService.scheduledTrainingsControllerUpdate),
  delete: extend(DashboardScheduledTrainingsService.scheduledTrainingsControllerDelete),
  deleteBulk: extend(DashboardScheduledTrainingsService.scheduledTrainingsControllerDeleteBulk),
  start: extend(DashboardScheduledTrainingsService.scheduledTrainingsControllerStart),
  getDetails: extend(DashboardScheduledTrainingsService.scheduledTrainingsControllerGetDetails),
  listSummaries: extend(DashboardScheduledTrainingsService.scheduledTrainingsControllerListSummaries),
});

const EmailReports = () =>
  ({
    createSchedule: extend(DashboardEmailReportsService.emailReportsControllerCreateSchedule),
    editScheduledJob: extend(DashboardEmailReportsService.emailReportsControllerUpdateScheduledJob),
    listScheduled: extend(DashboardEmailReportsService.emailReportsControllerListScheduled),
    listSubscriptionsByReport: extend(DashboardEmailReportsService.emailReportsControllerListSubscriptionsByReport),
    getSubscriptionDetail: extend(DashboardEmailReportsService.emailReportsControllerGetSubscriptionDetail),
    listApproverCandidateEmails: extend(DashboardEmailReportsService.emailReportsControllerListApproverCandidateEmails),
    getSubscriptionSendHistory: extend(DashboardEmailReportsService.emailReportsControllerGetSubscriptionSendHistory),
    previewHistoricalSend: extend(DashboardEmailReportsService.emailReportsControllerPreviewHistoricalSend),
    getLastSentCopy: extend(DashboardEmailReportsService.emailReportsControllerGetLastSentCopy),
    getReportSendLog: extend(DashboardEmailReportsService.emailReportsControllerGetReportSendLog),
    deleteScheduledJob: extend(DashboardEmailReportsService.emailReportsControllerDeleteScheduledJob),
    startScheduledJob: extend(DashboardEmailReportsService.emailReportsControllerStartScheduledJob),
    sendPendingReport: extend(DashboardEmailReportsService.emailReportsControllerSendPendingReport),
    rejectPendingReport: extend(DashboardEmailReportsService.emailReportsControllerRejectPendingReport),
    previewPendingReport: extend(DashboardEmailReportsService.emailReportsControllerPreviewPendingReport),
    previewTemplate: extend(DashboardEmailReportsService.emailReportsControllerPreviewTemplate),
    updateSummaryText: extend(DashboardEmailReportsService.emailReportsControllerUpdateSummaryText),
  }) as const;

const CameraCalibrations = () =>
  ({
    getScheduledJob: extend(DashboardCameraCalibrationService.cameraCalibrationControllerGetScheduledJob),
    createSchedule: extend(DashboardCameraCalibrationService.cameraCalibrationControllerCreateSchedule),
    updateSchedule: extend(DashboardCameraCalibrationService.cameraCalibrationControllerUpdateScheduledJob),
    getJob: extend(DashboardCameraCalibrationService.cameraCalibrationControllerGetJob),
    cancelJob: extend(DashboardCameraCalibrationService.cameraCalibrationControllerCancelJob),
    stopJob: extend(DashboardCameraCalibrationService.cameraCalibrationControllerStopJob),
    deleteJob: extend(DashboardCameraCalibrationService.cameraCalibrationControllerDeleteJob),
    deleteJobsBulk: extend(DashboardCameraCalibrationService.cameraCalibrationControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardCameraCalibrationService.cameraCalibrationControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardCameraCalibrationService.cameraCalibrationControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardCameraCalibrationService.cameraCalibrationControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardCameraCalibrationService.cameraCalibrationControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardCameraCalibrationService.cameraCalibrationControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardCameraCalibrationService.cameraCalibrationControllerUpdateJob),
    cancelScheduled: extend(DashboardCameraCalibrationService.cameraCalibrationControllerCancelScheduledJob),
    stopScheduled: extend(DashboardCameraCalibrationService.cameraCalibrationControllerStopScheduledJob),
    // pauseScheduled:
    //   DashboardCameraCalibrationService.cameraCalibrationControllerPauseScheduledJob)),
    resumeScheduled: extend(DashboardCameraCalibrationService.cameraCalibrationControllerResumeScheduledJob),
    deleteScheduled: extend(DashboardCameraCalibrationService.cameraCalibrationControllerDeleteScheduledJob),
    startJob: extend(DashboardCameraCalibrationService.cameraCalibrationControllerStartJob),
    startScheduled: extend(DashboardCameraCalibrationService.cameraCalibrationControllerStartScheduledJob),
    listSummaries: extend(DashboardCameraCalibrationService.cameraCalibrationControllerListSummaries),
    listScheduled: extend(DashboardCameraCalibrationService.cameraCalibrationControllerListScheduled),
  }) as const;

const UploadVideos = () =>
  ({
    getScheduledJob: extend(DashboardUploadVideosService.uploadVideosControllerGetScheduledJob),
    createSchedule: extend(DashboardUploadVideosService.uploadVideosControllerCreateSchedule),
    updateSchedule: extend(DashboardUploadVideosService.uploadVideosControllerUpdateScheduledJob),
    getJob: extend(DashboardUploadVideosService.uploadVideosControllerGetJob),
    cancelJob: extend(DashboardUploadVideosService.uploadVideosControllerCancelJob),
    stopJob: extend(DashboardUploadVideosService.uploadVideosControllerStopJob),
    deleteJob: extend(DashboardUploadVideosService.uploadVideosControllerDeleteJob),
    deleteJobsBulk: extend(DashboardUploadVideosService.uploadVideosControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardUploadVideosService.uploadVideosControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardUploadVideosService.uploadVideosControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardUploadVideosService.uploadVideosControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardUploadVideosService.uploadVideosControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardUploadVideosService.uploadVideosControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardUploadVideosService.uploadVideosControllerUpdateJob),
    cancelScheduled: extend(DashboardUploadVideosService.uploadVideosControllerCancelScheduledJob),
    stopScheduled: extend(DashboardUploadVideosService.uploadVideosControllerStopScheduledJob),
    // pauseScheduled:
    //   DashboardUploadVideosService.uploadVideosControllerPauseScheduledJob),
    resumeScheduled: extend(DashboardUploadVideosService.uploadVideosControllerResumeScheduledJob),
    deleteScheduled: extend(DashboardUploadVideosService.uploadVideosControllerDeleteScheduledJob),
    startJob: extend(DashboardUploadVideosService.uploadVideosControllerStartJob),
    startScheduled: extend(DashboardUploadVideosService.uploadVideosControllerStartScheduledJob),
    listSummaries: extend(DashboardUploadVideosService.uploadVideosControllerListSummaries),
    listScheduled: extend(DashboardUploadVideosService.uploadVideosControllerListScheduled),
  }) as const;

const CapacityTagging = () =>
  ({
    preCheck: extend(DashboardCapacityTaggingService.capacityTaggingControllerPreCheck),
    getScheduledJob: extend(DashboardCapacityTaggingService.capacityTaggingControllerGetScheduledJob),
    createSchedule: extend(DashboardCapacityTaggingService.capacityTaggingControllerCreateSchedule),
    updateSchedule: extend(DashboardCapacityTaggingService.capacityTaggingControllerUpdateScheduledJob),
    getJob: extend(DashboardCapacityTaggingService.capacityTaggingControllerGetJob),
    cancelJob: extend(DashboardCapacityTaggingService.capacityTaggingControllerCancelJob),
    stopJob: extend(DashboardCapacityTaggingService.capacityTaggingControllerStopJob),
    deleteJob: extend(DashboardCapacityTaggingService.capacityTaggingControllerDeleteJob),
    deleteJobsBulk: extend(DashboardCapacityTaggingService.capacityTaggingControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardCapacityTaggingService.capacityTaggingControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardCapacityTaggingService.capacityTaggingControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardCapacityTaggingService.capacityTaggingControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardCapacityTaggingService.capacityTaggingControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardCapacityTaggingService.capacityTaggingControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardCapacityTaggingService.capacityTaggingControllerUpdateJob),
    cancelScheduled: extend(DashboardCapacityTaggingService.capacityTaggingControllerCancelScheduledJob),
    stopScheduled: extend(DashboardCapacityTaggingService.capacityTaggingControllerStopScheduledJob),
    resumeScheduled: extend(DashboardCapacityTaggingService.capacityTaggingControllerResumeScheduledJob),
    deleteScheduled: extend(DashboardCapacityTaggingService.capacityTaggingControllerDeleteScheduledJob),
    startJob: extend(DashboardCapacityTaggingService.capacityTaggingControllerStartJob),
    startScheduled: extend(DashboardCapacityTaggingService.capacityTaggingControllerStartScheduledJob),
    listSummaries: extend(DashboardCapacityTaggingService.capacityTaggingControllerListSummaries),
    listScheduled: extend(DashboardCapacityTaggingService.capacityTaggingControllerListScheduled),
  }) as const;

const RecoveryEstimates = () =>
  ({
    preCheck: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerPreCheck),
    getScheduledJob: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerGetScheduledJob),
    createSchedule: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerCreateSchedule),
    updateSchedule: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerUpdateScheduledJob),
    getJob: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerGetJob),
    cancelJob: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerCancelJob),
    stopJob: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerStopJob),
    deleteJob: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerDeleteJob),
    deleteJobsBulk: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerUpdateJob),
    cancelScheduled: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerCancelScheduledJob),
    stopScheduled: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerStopScheduledJob),
    resumeScheduled: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerResumeScheduledJob),
    deleteScheduled: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerDeleteScheduledJob),
    startJob: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerStartJob),
    startScheduled: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerStartScheduledJob),
    listSummaries: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerListSummaries),
    listScheduled: extend(DashboardRecoveryEstimatesService.recoveryEstimatesControllerListScheduled),
  }) as const;

const HeadBlurImages = () =>
  ({
    getScheduledJob: extend(DashboardHeadBlurImagesService.headBlurImagesControllerGetScheduledJob),
    createSchedule: extend(DashboardHeadBlurImagesService.headBlurImagesControllerCreateSchedule),
    updateSchedule: extend(DashboardHeadBlurImagesService.headBlurImagesControllerUpdateScheduledJob),
    getJob: extend(DashboardHeadBlurImagesService.headBlurImagesControllerGetJob),
    cancelJob: extend(DashboardHeadBlurImagesService.headBlurImagesControllerCancelJob),
    stopJob: extend(DashboardHeadBlurImagesService.headBlurImagesControllerStopJob),
    deleteJob: extend(DashboardHeadBlurImagesService.headBlurImagesControllerDeleteJob),
    deleteJobsBulk: extend(DashboardHeadBlurImagesService.headBlurImagesControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardHeadBlurImagesService.headBlurImagesControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardHeadBlurImagesService.headBlurImagesControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardHeadBlurImagesService.headBlurImagesControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardHeadBlurImagesService.headBlurImagesControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardHeadBlurImagesService.headBlurImagesControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardHeadBlurImagesService.headBlurImagesControllerUpdateJob),
    cancelScheduled: extend(DashboardHeadBlurImagesService.headBlurImagesControllerCancelScheduledJob),
    stopScheduled: extend(DashboardHeadBlurImagesService.headBlurImagesControllerStopScheduledJob),
    resumeScheduled: extend(DashboardHeadBlurImagesService.headBlurImagesControllerResumeScheduledJob),
    deleteScheduled: extend(DashboardHeadBlurImagesService.headBlurImagesControllerDeleteScheduledJob),
    startJob: extend(DashboardHeadBlurImagesService.headBlurImagesControllerStartJob),
    startScheduled: extend(DashboardHeadBlurImagesService.headBlurImagesControllerStartScheduledJob),
    listSummaries: extend(DashboardHeadBlurImagesService.headBlurImagesControllerListSummaries),
    listScheduled: extend(DashboardHeadBlurImagesService.headBlurImagesControllerListScheduled),
  }) as const;

const HeadBlurVideos = () =>
  ({
    getScheduledJob: extend(DashboardHeadBlurVideosService.headBlurVideosControllerGetScheduledJob),
    createSchedule: extend(DashboardHeadBlurVideosService.headBlurVideosControllerCreateSchedule),
    updateSchedule: extend(DashboardHeadBlurVideosService.headBlurVideosControllerUpdateScheduledJob),
    getJob: extend(DashboardHeadBlurVideosService.headBlurVideosControllerGetJob),
    cancelJob: extend(DashboardHeadBlurVideosService.headBlurVideosControllerCancelJob),
    stopJob: extend(DashboardHeadBlurVideosService.headBlurVideosControllerStopJob),
    deleteJob: extend(DashboardHeadBlurVideosService.headBlurVideosControllerDeleteJob),
    deleteJobsBulk: extend(DashboardHeadBlurVideosService.headBlurVideosControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardHeadBlurVideosService.headBlurVideosControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardHeadBlurVideosService.headBlurVideosControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardHeadBlurVideosService.headBlurVideosControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardHeadBlurVideosService.headBlurVideosControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardHeadBlurVideosService.headBlurVideosControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardHeadBlurVideosService.headBlurVideosControllerUpdateJob),
    cancelScheduled: extend(DashboardHeadBlurVideosService.headBlurVideosControllerCancelScheduledJob),
    stopScheduled: extend(DashboardHeadBlurVideosService.headBlurVideosControllerStopScheduledJob),
    resumeScheduled: extend(DashboardHeadBlurVideosService.headBlurVideosControllerResumeScheduledJob),
    deleteScheduled: extend(DashboardHeadBlurVideosService.headBlurVideosControllerDeleteScheduledJob),
    startJob: extend(DashboardHeadBlurVideosService.headBlurVideosControllerStartJob),
    startScheduled: extend(DashboardHeadBlurVideosService.headBlurVideosControllerStartScheduledJob),
    listSummaries: extend(DashboardHeadBlurVideosService.headBlurVideosControllerListSummaries),
    listScheduled: extend(DashboardHeadBlurVideosService.headBlurVideosControllerListScheduled),
  }) as const;

const UploadSamples = () =>
  ({
    getScheduledJob: extend(DashboardUploadSamplesService.uploadSamplesControllerGetScheduledJob),
    createSchedule: extend(DashboardUploadSamplesService.uploadSamplesControllerCreateSchedule),
    updateSchedule: extend(DashboardUploadSamplesService.uploadSamplesControllerUpdateScheduledJob),
    getJob: extend(DashboardUploadSamplesService.uploadSamplesControllerGetJob),
    cancelJob: extend(DashboardUploadSamplesService.uploadSamplesControllerCancelJob),
    stopJob: extend(DashboardUploadSamplesService.uploadSamplesControllerStopJob),
    deleteJob: extend(DashboardUploadSamplesService.uploadSamplesControllerDeleteJob),
    deleteJobsBulk: extend(DashboardUploadSamplesService.uploadSamplesControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardUploadSamplesService.uploadSamplesControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardUploadSamplesService.uploadSamplesControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardUploadSamplesService.uploadSamplesControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardUploadSamplesService.uploadSamplesControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardUploadSamplesService.uploadSamplesControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardUploadSamplesService.uploadSamplesControllerUpdateJob),
    cancelScheduled: extend(DashboardUploadSamplesService.uploadSamplesControllerCancelScheduledJob),
    stopScheduled: extend(DashboardUploadSamplesService.uploadSamplesControllerStopScheduledJob),
    // pauseScheduled:
    //   DashboardUploadSamplesService.uploadSamplesControllerPauseScheduledJob),
    resumeScheduled: extend(DashboardUploadSamplesService.uploadSamplesControllerResumeScheduledJob),
    deleteScheduled: extend(DashboardUploadSamplesService.uploadSamplesControllerDeleteScheduledJob),
    startJob: extend(DashboardUploadSamplesService.uploadSamplesControllerStartJob),
    startScheduled: extend(DashboardUploadSamplesService.uploadSamplesControllerStartScheduledJob),
    listSummaries: extend(DashboardUploadSamplesService.uploadSamplesControllerListSummaries),
    listScheduled: extend(DashboardUploadSamplesService.uploadSamplesControllerListScheduled),
  }) as const;

const SyncGroundTruths = () =>
  ({
    getScheduledJob: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerGetScheduledJob),
    createSchedule: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerCreateSchedule),
    updateSchedule: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerUpdateScheduledJob),
    getJob: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerGetJob),
    cancelJob: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerCancelJob),
    stopJob: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerStopJob),
    deleteJob: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerDeleteJob),
    deleteJobsBulk: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerUpdateJob),
    cancelScheduled: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerCancelScheduledJob),
    stopScheduled: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerStopScheduledJob),
    // pauseScheduled:
    //   DashboardSyncGroundTruthsService.syncGroundTruthsControllerPauseScheduledJob),
    resumeScheduled: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerResumeScheduledJob),
    deleteScheduled: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerDeleteScheduledJob),
    startJob: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerStartJob),
    startScheduled: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerStartScheduledJob),
    listSummaries: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerListSummaries),
    listScheduled: extend(DashboardSyncGroundTruthsService.syncGroundTruthsControllerListScheduled),
  }) as const;

const DeleteSamplesJob = () =>
  ({
    getScheduledJob: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerGetScheduledJob),
    createSchedule: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerCreateSchedule),
    updateSchedule: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerUpdateScheduledJob),
    getJob: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerGetJob),
    cancelJob: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerCancelJob),
    stopJob: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerStopJob),
    deleteJob: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerDeleteJob),
    deleteJobsBulk: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerUpdateJob),
    cancelScheduled: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerCancelScheduledJob),
    stopScheduled: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerStopScheduledJob),
    // pauseScheduled:
    //   DashboardDeleteSamplesService.deleteSamplesJobControllerPauseScheduledJob),
    resumeScheduled: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerResumeScheduledJob),
    deleteScheduled: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerDeleteScheduledJob),
    startJob: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerStartJob),
    startScheduled: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerStartScheduledJob),
    listSummaries: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerListSummaries),
    listScheduled: extend(DashboardDeleteSamplesService.deleteSamplesJobControllerListScheduled),
  }) as const;

const DeleteVideosJob = () =>
  ({
    getScheduledJob: extend(DashboardDeleteVideosService.deleteVideosJobControllerGetScheduledJob),
    createSchedule: extend(DashboardDeleteVideosService.deleteVideosJobControllerCreateSchedule),
    updateSchedule: extend(DashboardDeleteVideosService.deleteVideosJobControllerUpdateScheduledJob),
    getJob: extend(DashboardDeleteVideosService.deleteVideosJobControllerGetJob),
    cancelJob: extend(DashboardDeleteVideosService.deleteVideosJobControllerCancelJob),
    stopJob: extend(DashboardDeleteVideosService.deleteVideosJobControllerStopJob),
    deleteJob: extend(DashboardDeleteVideosService.deleteVideosJobControllerDeleteJob),
    deleteJobsBulk: extend(DashboardDeleteVideosService.deleteVideosJobControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardDeleteVideosService.deleteVideosJobControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardDeleteVideosService.deleteVideosJobControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardDeleteVideosService.deleteVideosJobControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardDeleteVideosService.deleteVideosJobControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardDeleteVideosService.deleteVideosJobControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardDeleteVideosService.deleteVideosJobControllerUpdateJob),
    cancelScheduled: extend(DashboardDeleteVideosService.deleteVideosJobControllerCancelScheduledJob),
    stopScheduled: extend(DashboardDeleteVideosService.deleteVideosJobControllerStopScheduledJob),
    // pauseScheduled:
    //   DashboardDeleteVideosService.deleteVideosJobControllerPauseScheduledJob),
    resumeScheduled: extend(DashboardDeleteVideosService.deleteVideosJobControllerResumeScheduledJob),
    deleteScheduled: extend(DashboardDeleteVideosService.deleteVideosJobControllerDeleteScheduledJob),
    startJob: extend(DashboardDeleteVideosService.deleteVideosJobControllerStartJob),
    startScheduled: extend(DashboardDeleteVideosService.deleteVideosJobControllerStartScheduledJob),
    listSummaries: extend(DashboardDeleteVideosService.deleteVideosJobControllerListSummaries),
    listScheduled: extend(DashboardDeleteVideosService.deleteVideosJobControllerListScheduled),
  }) as const;

const WorkerJobs = () =>
  ({
    getJobInput: extend(DashboardWorkerJobService.workerJobControllerGetJobInput),
    getScheduledJob: extend(DashboardWorkerJobService.workerJobControllerGetScheduledJob),
    createSchedule: extend(DashboardWorkerJobService.workerJobControllerCreateSchedule),
    updateSchedule: extend(DashboardWorkerJobService.workerJobControllerUpdateScheduledJob),
    getJob: extend(DashboardWorkerJobService.workerJobControllerGetJob),
    cancelJob: extend(DashboardWorkerJobService.workerJobControllerCancelJob),
    stopJob: extend(DashboardWorkerJobService.workerJobControllerStopJob),
    deleteJob: extend(DashboardWorkerJobService.workerJobControllerDeleteJob),
    deleteJobsBulk: extend(DashboardWorkerJobService.workerJobControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardWorkerJobService.workerJobControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardWorkerJobService.workerJobControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardWorkerJobService.workerJobControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardWorkerJobService.workerJobControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardWorkerJobService.workerJobControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardWorkerJobService.workerJobControllerUpdateJob),
    cancelScheduled: extend(DashboardWorkerJobService.workerJobControllerCancelScheduledJob),
    stopScheduled: extend(DashboardWorkerJobService.workerJobControllerStopScheduledJob),
    resumeScheduled: extend(DashboardWorkerJobService.workerJobControllerResumeScheduledJob),
    deleteScheduled: extend(DashboardWorkerJobService.workerJobControllerDeleteScheduledJob),
    startJob: extend(DashboardWorkerJobService.workerJobControllerStartJob),
    startScheduled: extend(DashboardWorkerJobService.workerJobControllerStartScheduledJob),
    listSummaries: extend(DashboardWorkerJobService.workerJobControllerListSummaries),
    listScheduled: extend(DashboardWorkerJobService.workerJobControllerListScheduled),
  }) as const;

const ServiceHealthChecks = () =>
  ({
    test: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerTest),
    createSchedule: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerCreateSchedule),
    listScheduled: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerListScheduled),
    getScheduledJob: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerGetScheduledJob),
    updateSchedule: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerUpdateScheduledJob),
    deleteScheduled: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerDeleteScheduledJob),
    startScheduled: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerStartScheduledJob),
    cancelScheduled: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerCancelScheduledJob),
    stopScheduled: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerStopScheduledJob),
    resumeScheduled: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerResumeScheduledJob),
    startJob: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerStartJob),
    listSummaries: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerListSummaries),
    getJob: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerGetJob),
    deleteJob: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerDeleteJob),
    deleteJobsBulk: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerUpdateJob),
    cancelJob: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerCancelJob),
    stopJob: extend(DashboardServiceHealthChecksService.serviceHealthChecksControllerStopJob),
  }) as const;

const Queues = () =>
  ({
    getSummary: extend(DashboardQueuesService.queuesControllerGetSummary),
    listQueueFailures: extend(DashboardQueuesService.queuesControllerListQueueFailures),
    patchQueueFailure: extend(DashboardQueuesService.queuesControllerPatchQueueFailure),
    resolveQueueFailure: extend(DashboardQueuesService.queuesControllerResolveQueueFailure),
    deleteQueueFailure: extend(DashboardQueuesService.queuesControllerDeleteQueueFailure),
    resolveQueueFailures: extend(DashboardQueuesService.queuesControllerResolveQueueFailures),
    deleteQueueFailures: extend(DashboardQueuesService.queuesControllerDeleteQueueFailures),
    listQueuePending: extend(DashboardQueuesService.queuesControllerListQueuePending),
    postQueuePending: extend(DashboardQueuesService.queuesControllerPostQueuePending),
    deleteQueuePending: extend(DashboardQueuesService.queuesControllerDeleteQueuePending),
  }) as const;

const Version = () =>
  ({
    getVersion: extend(VersionService.versionControllerVersion),
  }) as const;

const Currency = () =>
  ({
    getCurrencyList: extend(CurrencyService.currencyControllerVersion),
  }) as const;

const LookupTable = () =>
  ({
    listSummaries: extend(DashboardLookupTablesService.lookupTableControllerListSummaries),
    setLookupTable: extend(DashboardLookupTablesService.lookupTableControllerCreate),
  }) as const;

const Reporting = () =>
  ({
    getMetabaseUrl: extend(DashboardReportsService.metabaseControllerGetMetabaseUrl),
    generatePdf: () => `${OpenAPI.BASE}/api/v2/dashboard/reports/generate-pdf`,
    createReport: extend(DashboardReportsService.metabaseControllerCreateReport),
    deleteReport: extend(DashboardReportsService.metabaseControllerDeleteReport),
    listReports: extend(DashboardReportsService.metabaseControllerListReports),
    getReportDetails: extend(DashboardReportsService.metabaseControllerGetReportDetails),
    updateReport: extend(DashboardReportsService.metabaseControllerUpdateReport),
    sendTestReport: extend(DashboardReportsService.metabaseControllerSendTestReport),
    contactUs: extend(DashboardReportsService.metabaseControllerContactUs),
    updateReportUrl: extend(DashboardReportsService.metabaseControllerUpdateReportUrl),
    updateReportConfig: extend(DashboardReportsService.metabaseControllerUpdateReportConfig),
    getReportMetadata: extend(DashboardReportsService.metabaseControllerFetchReportMetadata),
    previewCustomReport: extend(DashboardReportsService.metabaseControllerPreviewCustomReport),
  }) as const;

const ReportsCompanion = () =>
  ({
    listChatTurns: extend(DashboardReportsCompanionService.reportsCompanionControllerListChatTurns),
    getChatConversation: extend(DashboardReportsCompanionService.reportsCompanionControllerGetChatConversation),
  }) as const;

const CatalogService = () =>
  ({
    listSummaries: extend(DashboardCatalogService.catalogControllerListSummaries),
    listMinimal: extend(DashboardCatalogService.catalogControllerListMinimal),
    getDetails: extend(DashboardCatalogService.catalogControllerGetDetails),
    getSitePrices: extend(DashboardCatalogService.catalogControllerGetSitePrices),
    createItem: extend(DashboardCatalogService.catalogControllerCreate),
    updateItem: extend(DashboardCatalogService.catalogControllerUpdate),
    deleteItem: extend(DashboardCatalogService.catalogControllerDelete),
    getLabels: extend(DashboardCatalogService.catalogControllerListLabels),
    getItemLabels: extend(DashboardCatalogService.catalogControllerGetLabels),
    getFamilies: extend(DashboardCatalogService.catalogControllerListFamilies),
    uploadCSV: extend(DashboardCatalogService.catalogControllerUpload),
    getLookupTable: extend(DashboardCatalogService.catalogControllerFind),
    updateOutOfScopeBulk: extend(DashboardCatalogService.catalogControllerUpdateOutOfScopeBulk),
    deleteBulk: extend(DashboardCatalogService.catalogControllerDeleteBulk),
    updateTagsBulk: extend(DashboardCatalogService.catalogControllerUpdateTagsBulk),
    getTags: extend(DashboardCatalogTaggingService.catalogTaggingControllerListTags),
    getTagDetails: extend(DashboardCatalogTaggingService.catalogTaggingControllerGetDetails),
    updateTag: extend(DashboardCatalogTaggingService.catalogTaggingControllerUpdateTag),
    deleteTag: extend(DashboardCatalogTaggingService.catalogTaggingControllerDeleteTag),
    mergeTags: extend(DashboardCatalogTaggingService.catalogTaggingControllerMergeTagTo),
    createTags: extend(DashboardCatalogTaggingService.catalogTaggingControllerCreateTags),
  }) as const;

const SitesService = () =>
  ({
    create: extend(DashboardSitesService.sitesControllerCreate),
    update: extend(DashboardSitesService.sitesControllerUpdate),
    getDetails: extend(DashboardSitesService.sitesControllerGetDetails),
    listSummaries: extend(DashboardSitesService.sitesControllerListSummaries),
    listMinimal: extend(DashboardSitesService.sitesControllerListMinimal),
    getAgentDeployments: extend(DashboardSitesService.sitesControllerGetVersionHistory),
    deployAgentVersion: extend(DashboardSitesService.sitesControllerDeployVersion),
    deployServiceVersion: extend(DashboardSitesService.sitesControllerDeployService),
    deployServiceVersionBulk: extend(DashboardSitesService.sitesControllerDeployServiceVersionBulk),
    deployConfigBulk: extend(DashboardSitesService.sitesControllerDeployConfigBulk),
    getServiceDeployments: extend(DashboardSitesService.sitesControllerGetServiceDeployments),
    getAvailableServiceVersions: extend(DashboardSitesService.sitesControllerGetAvailableServiceVersions),
    listAvailableComponentVersions: extend(DashboardSitesService.sitesControllerListAvailableComponentVersions),
    getLatestDeviceAgentVersion: extend(DashboardSitesService.sitesControllerGetLatestSiteDeviceDeployment),
    disconnectDeviceId: extend(DashboardSitesService.sitesControllerDelete),
    getRegions: extend(DashboardSitesService.sitesControllerGetRegions),
    getSubRegions: extend(DashboardSitesService.sitesControllerGetSubRegions),
    updateActivations: extend(DashboardSitesService.sitesControllerUpdateActivationTime),
    updateRegions: extend(DashboardSitesService.sitesControllerUpdateRegions),
    updateSiteGroupBulk: extend(DashboardSitesService.sitesControllerUpdateSiteGroupBulk),
    unAssignDevicesBulk: extend(DashboardSitesService.sitesControllerRemoveDevices),
    assignDevicesBulk: extend(DashboardSitesService.sitesControllerAddDevices),
    listTags: extend(DashboardSitesTaggingService.sitesTaggingControllerListTags),
    updateTagsBulk: extend(DashboardSitesService.sitesControllerUpdateTagsBulk),
    deployModelBulk: extend(DashboardSitesService.sitesControllerDeployModelBulk),
    getTags: extend(DashboardSitesTaggingService.sitesTaggingControllerListTags),
    getTagDetails: extend(DashboardSitesTaggingService.sitesTaggingControllerGetDetails),
    updateTag: extend(DashboardSitesTaggingService.sitesTaggingControllerUpdateTag),
    deleteTag: extend(DashboardSitesTaggingService.sitesTaggingControllerDeleteTag),
    mergeTags: extend(DashboardSitesTaggingService.sitesTaggingControllerMergeTagTo),
    createTags: extend(DashboardSitesTaggingService.sitesTaggingControllerCreateTags),
    uploadCSV: extend(DashboardSitesService.sitesControllerUpload),
    upsertOperationalHours: extend(DashboardSitesService.sitesControllerUpsertOperationalHours),
    upsertOperationalHoursBulk: extend(DashboardSitesService.sitesControllerUpsertOperationalHoursBulk),
  }) as const;

const SiteGroupsService = () =>
  ({
    listSummaries: extend(DashboardSiteGroupsService.siteGroupsControllerListSummaries),
    create: extend(DashboardSiteGroupsService.siteGroupsControllerCreate),
    details: extend(DashboardSiteGroupsService.siteGroupsControllerDetails),
    update: extend(DashboardSiteGroupsService.siteGroupsControllerUpdate),
    delete: extend(DashboardSiteGroupsService.siteGroupsControllerDelete),
    addSites: extend(DashboardSiteGroupsService.siteGroupsControllerAddSites),
    removeSites: extend(DashboardSiteGroupsService.siteGroupsControllerRemoveSites),
    getLabels: extend(DashboardSiteGroupsService.siteGroupsControllerGetLabels),
    downloadLabels: extend(DashboardSiteGroupsService.siteGroupsControllerDownloadLabels),
    // Raw URL, so it never passes through the request interceptor below; the account currently
    // being viewed has to be attached directly.
    downloadLabelsLink: (id: number) => {
      const accountId = (router.state.location.search as { accountId?: number } | undefined)?.accountId;
      return `${OpenAPI.BASE}/api/v2/dashboard/site-groups/${id}/labels/download${qs({ viewAccountId: accountId })}`;
    },
    bulkUpdateLabels: extend(DashboardSiteGroupsService.siteGroupsControllerBulkUpdateLabels),
    checkDuplicateLabel: extend(DashboardSiteGroupsService.siteGroupsControllerCheckDuplicateLabel),
    upsertOperationalHours: extend(DashboardSiteGroupsService.siteGroupsControllerUpsertOperationalHours),
    upsertOperationalHoursBulk: extend(DashboardSiteGroupsService.siteGroupsControllerUpsertOperationalHoursBulk),
  }) as const;

const SamplesPending = () =>
  ({
    listSummaries: extend(DashboardPendingSampleActionsService.pendingControllerListSummaries),
    listUploadOperations: extend(DashboardPendingSampleActionsService.pendingControllerListUploadOperations),
    cancelUploadOperation: extend(DashboardPendingSampleActionsService.pendingControllerCancelOperation),
    cancelSelected: extend(DashboardPendingSampleActionsService.pendingControllerCancelSelected),
  }) as const;

const DashboardAlerts = () =>
  ({
    create: extend(DashboardDashboardAlertsService.dashboardAlertsControllerCreateAlert),
  }) as const;

const PageViews = () =>
  ({
    report: extend(DashboardPageViewsService.pageViewsControllerReport),
  }) as const;

const Permissions = () =>
  ({
    listSummaries: extend(DashboardPermissionsService.permissionsControllerListSummaries),
    getAll: extend(DashboardPermissionsService.permissionsControllerGetAll),
    getUser: extend(DashboardPermissionsService.permissionsControllerGetUserPermissions),
    getEndpoints: extend(DashboardPermissionsService.permissionsControllerGetPermissionsEndpoints),
    reload: extend(DashboardPermissionsService.permissionsControllerReload),
    getTemplate: extend(DashboardPermissionsService.permissionsControllerGetPermissionsTemplate),
  }) as const;

const Jira = () =>
  ({
    getIssueTypes: extend(DashboardJiraService.jiraControllerGetIssueType),
    getProjectIssueTypes: extend(DashboardJiraService.jiraControllerGetProjectIssueTypes),
    getStates: extend(DashboardJiraService.jiraControllerGetState),
  }) as const;

const LabelDistribution = () =>
  ({
    listSummaries: extend(DashboardLabelDistributionService.labelDistributionControllerListLabelDistribution),
    count: extend(DashboardLabelDistributionService.labelDistributionControllerLabelDistributionCount),
  }) as const;

const Feedback = () =>
  ({
    createFeedback: extend(DashboardFeedbackService.feedbackControllerCreateFeedback),
  }) as const;

const ScheduledDeployments = () =>
  ({
    createSchedule: extend(DashboardDeployComponentsService.deployComponentsControllerCreateSchedule),
    updateSchedule: extend(DashboardDeployComponentsService.deployComponentsControllerUpdateScheduledJob),
    getScheduledJob: extend(DashboardDeployComponentsService.deployComponentsControllerGetScheduledJob),
    listScheduled: extend(DashboardDeployComponentsService.deployComponentsControllerListScheduled),
    deleteScheduled: extend(DashboardDeployComponentsService.deployComponentsControllerDeleteScheduledJob),
    startScheduled: extend(DashboardDeployComponentsService.deployComponentsControllerStartScheduledJob),
    stopScheduled: extend(DashboardDeployComponentsService.deployComponentsControllerStopScheduledJob),
    resumeScheduled: extend(DashboardDeployComponentsService.deployComponentsControllerResumeScheduledJob),
    cancelScheduled: extend(DashboardDeployComponentsService.deployComponentsControllerCancelScheduledJob),
    startJob: extend(DashboardDeployComponentsService.deployComponentsControllerStartJob),
    getJob: extend(DashboardDeployComponentsService.deployComponentsControllerGetJob),
    listJobs: extend(DashboardDeployComponentsService.deployComponentsControllerListSummaries),
    deleteJob: extend(DashboardDeployComponentsService.deployComponentsControllerDeleteJob),
    deleteJobsBulk: extend(DashboardDeployComponentsService.deployComponentsControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardDeployComponentsService.deployComponentsControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardDeployComponentsService.deployComponentsControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardDeployComponentsService.deployComponentsControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardDeployComponentsService.deployComponentsControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardDeployComponentsService.deployComponentsControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardDeployComponentsService.deployComponentsControllerUpdateJob),
    cancelJob: extend(DashboardDeployComponentsService.deployComponentsControllerCancelJob),
    stopJob: extend(DashboardDeployComponentsService.deployComponentsControllerStopJob),
  }) as const;

const ScheduledModelDeployments = () =>
  ({
    createSchedule: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerCreateSchedule),
    updateSchedule: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerUpdateScheduledJob),
    getScheduledJob: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerGetScheduledJob),
    listScheduled: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerListScheduled),
    deleteScheduled: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerDeleteScheduledJob),
    startScheduled: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerStartScheduledJob),
    stopScheduled: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerStopScheduledJob),
    resumeScheduled: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerResumeScheduledJob),
    cancelScheduled: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerCancelScheduledJob),
    startJob: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerStartJob),
    getJob: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerGetJob),
    listJobs: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerListSummaries),
    deleteJob: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerDeleteJob),
    deleteJobsBulk: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerUpdateJob),
    cancelJob: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerCancelJob),
    stopJob: extend(DashboardScheduleModelDeploymentsService.scheduleModelDeploymentsControllerStopJob),
  }) as const;

const ScheduledConfigDeployments = () =>
  ({
    createSchedule: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerCreateSchedule),
    updateSchedule: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerUpdateScheduledJob),
    getScheduledJob: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerGetScheduledJob),
    listScheduled: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerListScheduled),
    deleteScheduled: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerDeleteScheduledJob),
    startScheduled: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerStartScheduledJob),
    stopScheduled: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerStopScheduledJob),
    resumeScheduled: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerResumeScheduledJob),
    cancelScheduled: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerCancelScheduledJob),
    startJob: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerStartJob),
    getJob: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerGetJob),
    listJobs: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerListSummaries),
    deleteJob: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerDeleteJob),
    deleteJobsBulk: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerUpdateJob),
    cancelJob: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerCancelJob),
    stopJob: extend(DashboardScheduleConfigDeploymentsService.scheduleConfigDeploymentsControllerStopJob),
  }) as const;

const ScheduledRestarts = () =>
  ({
    createSchedule: extend(DashboardDeviceRestartService.deviceRestartControllerCreateSchedule),
    updateSchedule: extend(DashboardDeviceRestartService.deviceRestartControllerUpdateScheduledJob),
    getScheduledJob: extend(DashboardDeviceRestartService.deviceRestartControllerGetScheduledJob),
    listScheduled: extend(DashboardDeviceRestartService.deviceRestartControllerListScheduled),
    deleteScheduled: extend(DashboardDeviceRestartService.deviceRestartControllerDeleteScheduledJob),
    startScheduled: extend(DashboardDeviceRestartService.deviceRestartControllerStartScheduledJob),
    stopScheduled: extend(DashboardDeviceRestartService.deviceRestartControllerStopScheduledJob),
    resumeScheduled: extend(DashboardDeviceRestartService.deviceRestartControllerResumeScheduledJob),
    cancelScheduled: extend(DashboardDeviceRestartService.deviceRestartControllerCancelScheduledJob),
    startJob: extend(DashboardDeviceRestartService.deviceRestartControllerStartJob),
    getJob: extend(DashboardDeviceRestartService.deviceRestartControllerGetJob),
    listJobs: extend(DashboardDeviceRestartService.deviceRestartControllerListSummaries),
    deleteJob: extend(DashboardDeviceRestartService.deviceRestartControllerDeleteJob),
    deleteJobsBulk: extend(DashboardDeviceRestartService.deviceRestartControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardDeviceRestartService.deviceRestartControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardDeviceRestartService.deviceRestartControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardDeviceRestartService.deviceRestartControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardDeviceRestartService.deviceRestartControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardDeviceRestartService.deviceRestartControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardDeviceRestartService.deviceRestartControllerUpdateJob),
    cancelJob: extend(DashboardDeviceRestartService.deviceRestartControllerCancelJob),
    stopJob: extend(DashboardDeviceRestartService.deviceRestartControllerStopJob),
  }) as const;

const CatalogUploadJobs = () =>
  ({
    createSchedule: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerCreateSchedule),
    updateSchedule: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerUpdateScheduledJob),
    getScheduledJob: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerGetScheduledJob),
    listScheduled: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerListScheduled),
    deleteScheduled: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerDeleteScheduledJob),
    startScheduled: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerStartScheduledJob),
    stopScheduled: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerStopScheduledJob),
    resumeScheduled: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerResumeScheduledJob),
    cancelScheduled: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerCancelScheduledJob),
    startJob: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerStartJob),
    getJob: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerGetJob),
    listJobs: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerListSummaries),
    deleteJob: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerDeleteJob),
    deleteJobsBulk: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerDeleteJobsBulk),
    cancelJobsBulk: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerCancelJobsBulk),
    deleteScheduledBulk: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerDeleteScheduledJobsBulk),
    cancelScheduledBulk: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerCancelScheduledJobsBulk),
    stopScheduledBulk: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerStopScheduledJobsBulk),
    resumeScheduledBulk: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerResumeScheduledJobsBulk),
    updateJob: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerUpdateJob),
    cancelJob: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerCancelJob),
    stopJob: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerStopJob),
    getJobDevices: extend(DashboardCatalogUploadJobsService.catalogUploadJobControllerGetJobDevices),
  }) as const;

const Slack = () =>
  ({
    getAuthUrl: extend(DashboardSlackService.slackControllerGetSlackAuthUrl),
    getGlobalAuthUrl: extend(DashboardSlackService.slackControllerGetGlobalSlackAuthUrl),
  }) as const;

const NotificationsService = () =>
  ({
    listSummaries: extend(DashboardNotificationsService.notificationsControllerListSummaries),
    getDetails: extend(DashboardNotificationsService.notificationsControllerFindOne),
    create: extend(DashboardNotificationsService.notificationsControllerCreate),
    update: extend(DashboardNotificationsService.notificationsControllerUpdate),
    delete: extend(DashboardNotificationsService.notificationsControllerRemove),
    getActive: extend(DashboardNotificationsService.notificationsControllerGetActive),
    getActivePublic: extend(DashboardNotificationsService.notificationsControllerGetActivePublic),
  }) as const;

const MetricAlertsService = () =>
  ({
    create: extend(DashboardMetricAlertsService.metricAlertsControllerCreate),
    list: extend(DashboardMetricAlertsService.metricAlertsControllerList),
    getDetails: extend(DashboardMetricAlertsService.metricAlertsControllerGetById),
    update: extend(DashboardMetricAlertsService.metricAlertsControllerUpdate),
    delete: extend(DashboardMetricAlertsService.metricAlertsControllerRemove),
    preview: extend(DashboardMetricAlertsService.metricAlertsControllerPreview),
    test: extend(DashboardMetricAlertsService.metricAlertsControllerTest),
  }) as const;

const DomainAuthSettings = () =>
  ({
    list: extend(DashboardDomainAuthSettingsService.domainAuthSettingsControllerList),
    getDetails: extend(DashboardDomainAuthSettingsService.domainAuthSettingsControllerFindOne),
    create: extend(DashboardDomainAuthSettingsService.domainAuthSettingsControllerCreate),
    update: extend(DashboardDomainAuthSettingsService.domainAuthSettingsControllerUpdate),
    delete: extend(DashboardDomainAuthSettingsService.domainAuthSettingsControllerRemove),
  }) as const;

// Regions / sub-regions (ID-7056). `listSummaries` backs the single flat table; `listRegionOptions`
// and `listSubRegionOptions` back the filter dropdowns and the create/move selectors. Note there is
// no delete: removal is inactivation, expressed as ONE bulk PATCH over the selected rows, which
// retires whichever entity each row actually is.
//
// These names are hand-written and tsc does NOT check this file against the generated SDK -- a
// stale entry here compiles clean and fails at runtime as `extend(undefined)`. Re-check the
// right-hand side by name whenever a regions route is renamed.
const RegionsService = () =>
  ({
    listSummaries: extend(DashboardRegionsService.regionsControllerListSummaries),
    listRegionOptions: extend(DashboardRegionsService.regionsControllerListRegionOptions),
    listSubRegionOptions: extend(DashboardRegionsService.regionsControllerListSubRegionOptions),
    create: extend(DashboardRegionsService.regionsControllerCreate),
    updateRegion: extend(DashboardRegionsService.regionsControllerUpdateRegion),
    updateSubRegion: extend(DashboardRegionsService.regionsControllerUpdateSubRegion),
    inactivateBulk: extend(DashboardRegionsService.regionsControllerInactivateBulk),
    moveSubRegionsBulk: extend(DashboardRegionsService.regionsControllerMoveSubRegionsBulk),
    upload: extend(DashboardRegionsService.regionsControllerUpload),
  }) as const;

export const createClient = () =>
  ({
    alerts: AlertsService(),
    devices: DevicesService(),
    clusters: ClustersService(),
    auth: AuthService(),
    users: UsersService(),
    samples: SamplesService(),
    predictions: PredictionsService(),
    sessions: SessionsService(),
    models: ModelsService(),
    datasets: DatasetsService(),
    staticDatasets: StaticDatasets(),
    trainings: TrainingService(),
    scheduledTrainings: ScheduledTrainings(),
    accounts: AccountsService(),
    cameraCalibration: CameraCalibrations(),
    uploadVideos: UploadVideos(),
    capacityTagging: CapacityTagging(),
    recoveryEstimates: RecoveryEstimates(),
    headBlurImages: HeadBlurImages(),
    headBlurVideos: HeadBlurVideos(),
    uploadSamples: UploadSamples(),
    syncGroundTruths: SyncGroundTruths(),
    deleteSamples: DeleteSamplesJob(),
    deleteVideos: DeleteVideosJob(),
    workerJobs: WorkerJobs(),
    serviceHealthChecks: ServiceHealthChecks(),
    queues: Queues(),
    version: Version(),
    currency: Currency(),
    lookupTable: LookupTable(),
    reporting: Reporting(),
    tags: TagsService(),
    catalog: CatalogService(),
    sites: SitesService(),
    siteGroups: SiteGroupsService(),
    emailReports: EmailReports(),
    samplesPending: SamplesPending(),
    dashboardAlerts: DashboardAlerts(),
    pageViews: PageViews(),
    permissions: Permissions(),
    scheduledDeployments: ScheduledDeployments(),
    scheduledModelDeployments: ScheduledModelDeployments(),
    scheduledConfigDeployments: ScheduledConfigDeployments(),
    scheduledRestarts: ScheduledRestarts(),
    catalogUploadJobs: CatalogUploadJobs(),
    jira: Jira(),
    labelDistribution: LabelDistribution(),
    feedback: Feedback(),
    slack: Slack(),
    companion: ReportsCompanion(),
    notifications: NotificationsService(),
    metricAlerts: MetricAlertsService(),
    domainAuthSettings: DomainAuthSettings(),
    regions: RegionsService(),
  }) as const;

export type Client = ReturnType<typeof createClient>;

export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
if (BACKEND_URL) {
  OpenAPI.BASE = BACKEND_URL.replace(/localhost|127\.0\.0\.1/g, window.location.hostname).replaceAll(/\/+$/g, "");
}
OpenAPI.WITH_CREDENTIALS = true;
OpenAPI.interceptors.request.use((config) => {
  // The URL's own `accountId` search param is the single source of truth for account context --
  // read it directly off the router's live location rather than any per-tab cache, and forward
  // it to the backend as `viewAccountId`, not `accountId` -- some endpoints (e.g.
  // ClustersController.listMinimal) already have their own, unrelated `accountId` query field,
  // and a shared name would silently collide with it.
  const accountId = (router.state.location.search as { accountId?: number } | undefined)?.accountId;
  if (accountId !== undefined) {
    config.params = { ...config.params, viewAccountId: accountId };
  }
  return config;
});
// Guards the access-denied handler below against concurrent in-flight requests: router.navigate()
// is async, so several responses carrying the same resolvedAccountId can arrive and be processed
// before the first one's navigate() has actually updated router.state.location.search. Tracking
// the account id we're already mid-navigate for (not just comparing against current URL state)
// closes that window instead of double-firing the toast/invalidation for every such response.
let accountAccessDeniedInFlight: number | undefined;

OpenAPI.interceptors.response.use(async (response) => {
  // The URL named an account this user doesn't have access to -- the backend already fell back
  // to their default account for this response, but the URL itself still says otherwise. Bring
  // the URL in line with what actually got served, and surface it: this is a "we didn't honor
  // what you asked for" case, not a silent switch.
  if (response?.headers?.["x-account-access-denied"] === "true") {
    const resolvedAccountIdHeader = response.headers["x-resolved-account-id"];
    const resolvedAccountId = typeof resolvedAccountIdHeader === "string" && resolvedAccountIdHeader.trim() !== "" ? Number(resolvedAccountIdHeader) : NaN;
    const currentAccountId = (router.state.location.search as { accountId?: number } | undefined)?.accountId;
    // Two backend paths emit this signal: DashboardJwtStrategy's fallback when the URL asked for
    // an account the caller can't access (default `denied`, message tells them so); and
    // ValidateInAccountGuard's cross-account resolve when the URL's account didn't match the
    // resource's own account and the caller was entitled to it (`resource-scope`, message
    // announces the auto-adjustment instead of accusing them of a denied request).
    const reason = response.headers["x-account-access-reason"];
    const toastKey = reason === "resource-scope" ? "accountResolvedForResource" : "accountAccessDenied";
    // Several requests fired from one page load can all carry the same bad accountId and all
    // come back with this signal -- only act once. If the URL already reflects the resolved
    // account, an earlier response already handled this; if another response is already
    // mid-navigate for this same resolvedAccountId, don't double up before router.state catches up.
    if (!Number.isNaN(resolvedAccountId) && resolvedAccountId !== currentAccountId && resolvedAccountId !== accountAccessDeniedInFlight) {
      accountAccessDeniedInFlight = resolvedAccountId;
      try {
        await router.navigate({
          search: (prev: any) => ({ ...prev, accountId: resolvedAccountId }),
          replace: true,
          // The account-fallback rewrite is a same-path search-only sync, not a real
          // navigation-away. Without this, page-level `useBlocker` guards (e.g. the session's
          // "not all non-scans tagged" prompt in -session-tagging.tsx) fire against our own
          // interceptor as if the user were trying to leave.
          ignoreBlocker: true,
        } as any);
        queryClient.invalidateQueries();
        // useAccountSwitchDetector used to bridge account-context changes into closeAllDialogs()/
        // incrementCacheUniq() by polling /me; this is the one remaining case where the account
        // can change out from under the user without them initiating it, so re-signal those same
        // side effects via a plain DOM event (this module sits outside the React tree, so it can't
        // call those context hooks directly) -- see use-account-access-denied-effects.tsx.
        window.dispatchEvent(new Event("account-access-denied"));
        toast.warning(t(toastKey));
      } finally {
        accountAccessDeniedInFlight = undefined;
      }
    }
  }

  if (response?.status === 403) {
    const context = window.location.pathname !== "/login" ? window.location.pathname : undefined;
    router.navigate({ to: "/dashboard/unauthorized", search: (search) => ({ ...search, context }) });
  } else if ([401, 440].includes(response?.status)) {
    // The way back after the login: path AND search, so a deep link keeps its filters -- the shape
    // the /dashboard loader builds too, and what parseContext expects.
    const context = window.location.pathname !== "/login" ? `${window.location.pathname}${window.location.search ?? ""}` : undefined;
    FullStory("setIdentity", {
      anonymous: true,
      properties: {
        environment: window.location.hostname.replace("dashboard.", "").replace(".edgify.ai", ""),
      },
    });
    router.navigate({ to: "/login", search: { context, expired: response.status == 440 || undefined } });
  }

  return response;
});

export const client = createClient();
